<template>
  <el-container class="index-container">
    <el-header class="my-header">
      <div class="left">
        <i @click="collapse = !collapse" class="icon el-icon-s-fold"></i>
        <!-- <img class="logo" src="../../assets/index_logo.png" alt="" /> -->
        <span class="title">{{ title }}</span>
        <!--  :props="props" -->
        <!--   :options="options"
          v-model="houseArr" -->
        <el-cascader
          v-if="loginType == 1"
          style="margin-left: 30px"
          size="small"
          :props="props"
          @change="handleChangeValue"
          v-model="houseArr"
        ></el-cascader>
      </div>

      <div class="right">
        <!-- <span class="username">{{ roleName }}: {{ nickName }}</span>
        <el-button @click="logout" size="small" type="primary">退出</el-button> -->
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link username" style="cursor: pointer">
            <a class="user-avator" href="javascript:void(0)">
              <img src="@/assets/icon/default_avator.jpeg" />
            </a>
            {{ roleName }}: {{ nickName }}</span
          >
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">
              <a href="javascript:void(0)">修改密码</a>
            </el-dropdown-item>
            <el-dropdown-item command="b">
              <a href="javascript:void(0)">退出</a>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container>
      <el-aside class="my-aside" width="auto">
        <el-menu
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          router
          :collapse="collapse"
          unique-opened
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <template>
            <div v-for="val in newList" :key="val.path">
              <el-submenu :index="'/home/' + val.path" v-if="val.children">
                <template slot="title">
                  <i :class="val.meta.icon"></i>
                  <span>{{
                    val.meta.title === '酒店宴会报表管理'
                      ? '报表管理'
                      : val.meta.title
                  }}</span>
                </template>
                <el-menu-item-group
                  v-for="child in val.children"
                  :key="child.path"
                >
                  <el-menu-item
                    v-if="child.hidden !== true"
                    :index="'/home/' + val.path + '/' + child.path"
                    >{{ child.meta.title }}</el-menu-item
                  >
                </el-menu-item-group>
              </el-submenu>

              <el-menu-item :index="'/home/' + val.path" v-else>
                <i :class="val.meta.icon"></i>
                <span slot="title">{{ val.meta.title }}</span>
              </el-menu-item>
              <!-- <el-menu-item  :index="'/home/'+item.path" v-for="item in routeList" :key="item.path">
              <i  :class="item.meta.icon"></i> <span slot="title">{{item.meta.title}}</span>
            </el-menu-item> -->
            </div>
            <!-- <el-menu-item
              index="/home/examine"
              v-if="operationList.includes('examine')"
              ><i class="el-icon-money"></i>审批列表</el-menu-item
            > -->
          </template>
        </el-menu>
      </el-aside>
      <el-main class="my-main rrr">
        <router-view></router-view>
      </el-main>
    </el-container>
    <ChangePassword ref="changePassword"></ChangePassword>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { getToken, saveToken, removeToken } from '@/utils/token.js';
// import { getAreaListApi, getHouseByAreaApi } from '@/api/areaApi.js';
import ChangePassword from '@/components/ChangePassword';
import { getAreaListApi } from '@/api/areaApi.js';
import { houseDropList } from '@/api/houseApi.js';
import { getRolePermitAccountApi } from '@/api/user';
import { filterMenu } from '@/filters/index.js';
import { decrypt } from '@/utils/encryp';
export default {
  name: 'index',
  inject: ['reload'],
  components: {
    ChangePassword,
  },
  data() {
    return {
      houseArr: [],
      collapse: false,
      editableTabs: [],
      options: [],
      newList: [],
      editableTabsValue: '',
      childRouteList: [], // 组件下有子组件的
      routeList: [],
      roleName: '', // 组件下没有子组件的
      nickName: '', // 组件下没有子组件的
      cascaderVal: '',
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          // console.log('level', level);
          const userInfo = JSON.parse(getToken('userInfo'));
          // console.log('userInfo', userInfo);
          let { areaId, roleType } = userInfo;
          if (level == 0) {
            getAreaListApi({ areaId, roleType }).then((res) => {
              if (res.code === 200) {
                const arr = res.data.area.map((item) => {
                  return {
                    value: item.areaId,
                    label: item.areaName,
                    leaf: !item.houseDtos.length,
                  };
                });
                this.options = arr;
                resolve(arr);
              }
            });
          } else if (level == 1) {
            const { value } = node;
            const index = this.options.findIndex(
              (child) => child.value == value
            );
            houseDropList({ areaId: value, pageIndex: 1, pageSize: 999 }).then(
              (res) => {
                if (res.code === 200) {
                  const arr = res.data.dataList.map((item) => {
                    return {
                      value: item.houseId,
                      label: item.houseName,
                      leaf: true,
                    };
                  });
                  this.options[index].children = arr;
                  saveToken(JSON.stringify(this.options), 'options');
                  resolve(arr);
                }
              }
            );
            // console.log(value, 'node');
          }
        },
      },
      loginType: '',
      title: '',
    };
  },
  computed: {
    ...mapGetters(['menuList', 'operationList']),
    currentRouterObj() {
      return this.$route;
    },
  },
  created() {
    // this.options.map((item) => {
    //   if (!item.children) {
    //     item.children = [];
    //   }
    // });
    // console.log('楼盘列表', this.options);
    // this.houseArr = JSON.parse(getToken('houserArr'));
    // console.log('houserArr', this.houseArr);
    const userInfo = getToken('userInfo')
      ? JSON.parse(getToken('userInfo'))
      : this.$store.state.user.userInfo;
    this.loginType = getToken('loginType')
      ? JSON.parse(getToken('loginType'))
      : '';
    this.title =
      this.loginType == 1
        ? '开始赚后台管理系统'
        : this.loginType == 2
        ? '物业服务后台管理系统'
        : '酒店宴会后台管理系统';
    this.roleName = userInfo.roleName;
    this.nickName = decrypt(userInfo.nickName);
    this.filterRouter();
    const areaId = JSON.parse(getToken('areaId')).areaId;
    this.$set(this.houseArr, 0, areaId);
    if (userInfo.houseId) {
      this.$set(this.houseArr, 1, userInfo.houseId);
    }

    // this.getHouseList(areaId);
    this.getAreaList();
  },
  methods: {
    //
    handleCommand(command) {
      if (command == 'a') {
        this.handleModify();
      } else if (command == 'b') {
        this.logout();
      }
    },
    // 过滤路由
    filterRouter() {
      // console.log('菜单路由====》', this.menuList);
      this.newList = this.menuList;
      // this.$router.addRoutes(this.menuList);
    },
    handleChangeValue(arr) {
      if (arr.length > 1) {
        const houseId = arr[1];
        const userInfo = JSON.parse(getToken('userInfo'));
        userInfo.houseId = houseId;
        saveToken(JSON.stringify(userInfo), 'userInfo');
        saveToken(JSON.stringify({ areaId: arr[0] }), 'areaId');
        saveToken(JSON.stringify(arr), 'houserArr');
        // console.log(this.menuList[0]);

        getRolePermitAccountApi({
          houseId: userInfo.houseId,
        }).then((res) => {
          if (res.code === 200) {
            let resData = [...res.data];
            let realMenu = [];
            let obj = {};
            for (let i = 0; i < resData.length; i++) {
              let item = resData[i];
              const menuChild = resData.find(
                (child) => child.menu.superId.trim() == item.menu.menuId
              );
              if (
                (menuChild ||
                  JSON.stringify(item.permits).indexOf('_Catalogue') != -1) &&
                item.permits
              ) {
                realMenu.push(item);
              } //返回父节点或有目录权限的子菜单
              obj[item.menu.url] = item.permits
                ? item.permits.map((child) => child.code)
                : [];
            }
            let array1 = filterMenu(realMenu); //过滤为父子形式

            this.$store.dispatch('role/setRoleList', obj); //存储权限
            this.$store.dispatch('role/setMenuList', array1); //存储菜单
            // console.log("执行了此函数")

            // console.log('array1', array1);

            this.reload();
            let { name } = array1[0];
            this.$router.replace({
              name,
            });
          }
        });
        // this.$router.go(0);
      }
    },
    // 获取区域
    getAreaList() {
      const userInfo = JSON.parse(getToken('userInfo'));
      // console.log('userInfo', userInfo);
      let { areaId, roleType } = userInfo;
      getAreaListApi({ areaId, roleType }).then((res) => {
        if (res.code === 200) {
          // console.log(res.data, 'lalala');
          this.options = res.data.area.map((item) => {
            return {
              value: item.areaId,
              label: item.areaName,
              leaf: false,
            };
          });
        }
      });
    },
    // 获取楼盘
    getHouseList(areaId) {
      houseDropList({ areaId, pageIndex: 1, pageSize: 999 }).then((res) => {
        if (res.code === 200) {
          let ary = res.data.dataList.map((item) => {
            return {
              value: item.houseId,
              label: item.houseName,
              leaf: true,
            };
          });
          // this.options.concat(ary);
          this.options.map((item) => {
            if (item.value == areaId) {
              item.children = ary;
            }
          });
        }
      });
    },
    // 修改密码
    handleModify() {
      this.$refs.changePassword.dialogFormVisible = true;
    },
    // 退出登录
    logout() {
      this.$confirm('您确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        removeToken();
        removeToken('userInfo');
        removeToken('areaId');
        removeToken('loginType');
        // _this.reload();
        this.reload();
        this.$store.dispatch('role/setRoleList', null);
        this.$store.dispatch('role/setMenuList', null);
        this.$router.push('/login');
      });
    },

    // 用于标签式导航 --- 增加标签 (暂时没用)
    addTab(targetName) {
      if (this.editableTabs.length === 0) {
        this.editableTabs.push(targetName);
      } else {
        // 如果数组中没有同样的，说明没有添加
        let bol = this.editableTabs.every((item) => {
          return item.name !== targetName.name;
        });
        bol === true ? this.editableTabs.push(targetName) : '';
      }
      this.currentRouterObj = targetName;
    },

    // 用于标签式导航 -- 删除标签 (暂时没用)
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.currentRouterObj.name;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
    },
  },
};
</script>

<style lang="less" scoped>
.index-container {
  height: 100%;
  .my-header {
    // background: yellow;
    display: flex;
    background: rgb(84, 92, 100);
    border-bottom: 1px #696969 solid;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      .icon {
        font-size: 24px;
        margin-right: 12px;
        cursor: pointer;
        color: #ffffff;
      }
      .logo {
        margin-right: 11px;
      }
      .title {
        font-size: 22px;
        color: #ffffff;
        font-weight: 400;
      }
    }
    .right {
      display: flex;
      align-items: center;
      .avatar {
        width: 43px;
        height: 43px;
        border-radius: 50%;
        margin-right: 9px;
      }
      .user-avator {
        width: 40px;
        height: 40px;
        display: inline-block;
        margin-right: 10px;
        > img {
          width: 100%;
          height: 100%;
          border-radius: 50%;

          display: inline-block;
        }
      }
      .username {
        font-size: 14px;
        color: #ffffff;
        margin-right: 38px;
      }
    }
  }
  .my-aside {
    background-color: #545c64;
  }
  // .my-main {
  //   background: #ccc;
  // }

  // 导航菜单的 样式
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }

  // 二级菜单样式
  .el-submenu .el-menu-item {
    width: 80%;
    height: 40px;
    line-height: 40px;
    padding-left: 60px !important;
  }

  /deep/ .el-menu-item-group__title {
    padding: 0;
  }
}
</style>
<style lang="less">
.index-container {
  .el-dropdown-link {
    display: flex;
    align-items: center;
  }
}
a {
  text-decoration: none !important;
  color: #000;
}
</style>
